import {Component, OnInit} from '@angular/core';
import {AppSettings} from '../models/AppSettings';
import {AppMenu} from '../models/AppMenu';
import {UserService} from '../service/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-tws-home',
    templateUrl: './tws-home.component.html',
    styleUrls: ['./tws-home.component.css']
})

export class TwsHomeComponent implements OnInit {
    menu: Array<AppMenu>;
    constructor(private service: UserService, private router: Router) {
        this.menu = AppSettings.listaMenu;
    }

    ngOnInit() {
        this.service.getLoginEvent().subscribe(item => {
            
                if (!item) {
                    this.router.navigate(['login']);
                }
            
        });
    }
    
    get utente():any{
        return this.service.getProfilo();
    }
get sezione() {
        return AppSettings.sezione;
    }
} 



// WEBPACK FOOTER //
// ./src/app/tws-home/tws-home.component.ts